<div *ngIf="products?.length"
  [class]="'relative ' + dirClass"
  [attr.dir]="dirClass"
  [ngStyle]="primaryThemeColor ? { '--carousel-primary': primaryThemeColor } : {}">
  <div class="carousel-viewport overflow-hidden ltr rounded-md"
    (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">
    <div class="carousel-track flex transition-transform duration-300 ease-in-out"
      [style.transform]="'translate3d(-' + (currentProductIndex * 100 / itemsPerPage) + '%, 0, 0)'">
      <div *ngFor="let product of products; let slideIdx = index" class="carousel-slide-pane flex-shrink-0 min-w-0 px-1 py-1"
        [style.flex]="'0 0 ' + (100 / itemsPerPage) + '%'">
        <div class="carousel-slide flex flex-col h-full min-w-0">
          <div class="carousel-slide-media">
            <img *ngIf="product.productImage" [src]="product.productImage" [alt]="getProductLabel(product) || 'Product'"
              class="carousel-slide-img"
              loading="eager"
              decoding="async"
              [attr.fetchpriority]="slideIdx <= currentProductIndex + itemsPerPage + 1 ? 'high' : 'low'" />
          </div>

          <div [class]="'pt-2 ' + dirClass" [attr.dir]="dirClass">
            <div *ngFor="let detail of product.productDetails">
              <ng-container *ngIf="detail.language == lang && product.link && product.link !== ''">
                <a [href]="product.link" rel="noopener noreferrer" class="flex block cursor-pointer"
                  (click)="$event.preventDefault(); trackLinkClick('image_carousel', product.link, getProductLabel(product))">
                  <div class="flex items-center justify-between w-full gap-2">
                    <h4 class="font-bold text-lg p-[0.1rem]" [ngStyle]="secondaryThemeStyle">
                      {{ detail.title }}
                    </h4>
                  </div>
                </a>
              </ng-container>

              <ng-container *ngIf="detail.language == lang && (!product.link || product.link === '')">
                <h4 class="font-bold text-lg p-[0.1rem]" [ngStyle]="secondaryThemeStyle">
                  {{ detail.title }}
                </h4>
              </ng-container>

              <p *ngIf="detail.language == lang" class="contact_infotext p-1 w-full"
                [ngStyle]="{ color: primaryTextColor }">
                {{ detail.short_description }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Bottom middle progress circles -->
  <div *ngIf="maxIndex > 0" [class]="'carousel-indicators ' + dirClass" [attr.dir]="dirClass">
    <button type="button" *ngFor="let idx of pageIndexes" class="indicator-dot" [class.active]="idx === currentProductIndex"
      (click)="goTo(idx)" [attr.aria-label]="'Go to slide ' + (idx + 1)"></button>
  </div>
</div>